import { useContext } from 'react';
import { BusinessContext } from '../contexts/BusinessContext';

export function useBusinessId() {
    const context = useContext(BusinessContext);
    return context?.businessId;
} 